<template>
  <div class="page-dialog">
    <errors-list :errors="errorList" />
    <el-form
      ref="addressForm"
      style="height: 300px"
      inline
      size="mini"
      :show-message="false"
      label-width="90px"
      :model="conditions"
      :rules="rules"
    >
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="收货单位" prop="receiveUnitName">
            <el-input
              v-model="conditions.receiveUnitName"
              clearable
              suffix-icon="el-icon-more"
              @focus="openDialog"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="contactNumber">
            <el-input v-model="conditions.contactNumber" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收货联系人" prop="contacPerson">
            <el-input v-model="conditions.contacPerson" />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="收货地址" prop="receiveAddress">
            <el-input :value="conditions.receiveAddress" type="textarea" disabled />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      v-dialogDrag
      title="收货单位"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <common-address
          ref="Addressdialog"
          :partner="partner"
        />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="confirmSelect"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonAddress from '@/components/dialog/CommonAddress.vue'

export default {
  components: { CommonAddress },
  props: {
    partner: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rules: {
        receiveUnitName: [{ required: true, message: '请选择收货单位', trigger: 'change' }],
        contactNumber: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        receiveAddress: [{ required: true, message: '请输入收货地址', trigger: 'blur' }],
        contacPerson: [{ required: true, message: '请输入收货联系人', trigger: 'blur' }]
      },
      errorList: [],
      showDialog: false,
      conditions: {
        receiveUnitName: '',
        receiveUnitCode: '',
        contactNumber: '',
        receiveAddress: '',
        contacPerson: '',
        remark: ''
      }
    }
  },
  methods: {
    openDialog(e) {
      e.target.blur()
      this.showDialog = true
    },
    async confirmSelect() {
      const data = await this.$refs.Addressdialog.submitForm()
      if (data) {
        this.conditions.receiveUnitName = data.PARTNER_NAME
        this.conditions.receiveUnitCode = data.PARTNER
        this.conditions.contacPerson = data.C_O_NAME
        this.conditions.contactNumber = data.TEL_NUMBER
        this.conditions.receiveAddress = data.STREET
      }
      this.showDialog = false
    },
    async submitForm() {
      this.errorList = []
      const bool = await this.$refs.addressForm.validate()
      if (bool) {
        this.conditions.remark = this.conditions.contacPerson
        if (this.conditions.contactNumber != '') {
          this.conditions.remark += '[' + this.conditions.contactNumber + ']'
        }
        this.conditions.remark += this.conditions.receiveAddress
        return Promise.resolve(this.conditions)
      } else {
        this.errorList.push('请填写必填项！')
        return undefined
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/components/AddressInfo.vue